import RankingDetail from "../../components/RankingDetail";
function RankingDetailPage() {
  return <RankingDetail />;
}

export default RankingDetailPage;
